module.exports = __webpack_public_path__ + "static/Erik-Rousi-fb09022367f37afab6ece54c63bc8222.jpeg";